<pos-table tableFormId="employeeTable" 
[data]="employees" 
[headers]="getEmployeeHeaders()"
      [filters]="getEmployeeFilters()" 
      (dataChange)="getEmployeeData($event)" 
      [itemsPerPage]="10"
      (rowClick)="selectEmployee($event)">
    </pos-table>